import type { Annotation } from "building-types/annotation/annotationTypes";
import type { PrimaryEntityId } from "building-types/doc/primaryEntityId";
import type { Table } from "common/data/table";
import {
  SystemAreaRoomTagTemplate,
  SystemCeilingHeightRoomTagTemplate,
  SystemDimensionsRoomTagTemplate,
  SystemFloorMaterialRoomTagTemplate,
  SystemRoomTagTemplate,
  SystemViewportTitleDrawingTemplate,
} from "doc/systemDrawingTemplates";
import {
  generateAreaRoomTag,
  generateCeilingHeightRoomTag,
  generateDefaultRoomTag,
  generateDimensionsRoomTag,
  generateFloorMaterialRoomTag,
} from "./systemRoomTagAnnotations";
import { generateDefaultViewportTitleAnnotation } from "./systemViewportTitleAnnotation";

const annotationGeneratorFunctionMap = {
  [SystemViewportTitleDrawingTemplate.id]: generateDefaultViewportTitleAnnotation,
  [SystemRoomTagTemplate.id]: generateDefaultRoomTag,
  [SystemCeilingHeightRoomTagTemplate.id]: generateCeilingHeightRoomTag,
  [SystemFloorMaterialRoomTagTemplate.id]: generateFloorMaterialRoomTag,
  [SystemDimensionsRoomTagTemplate.id]: generateDimensionsRoomTag,
  [SystemAreaRoomTagTemplate.id]: generateAreaRoomTag,
};

export function getSystemContentTemplateAnnotations(id: PrimaryEntityId<"CONTENT_TEMPLATE">): Table<Annotation> {
  const generatorFunction = annotationGeneratorFunctionMap[id];
  if (!generatorFunction) {
    return {};
  }
  return generatorFunction();
}
